import {
  UPDATE_PLUGIN_SET_FILTER_ORDER,
  UPDATE_PLUGIN_SET_FILTER,
  UPDATE_PLUGIN_SET,
  ADD_PLUGIN_SET_FILTER
} from '../actions';
import findIndex from 'lodash/findIndex';

const setFilterSortOrders = (filters) => {
  return filters.map((filter, i) => {
    return { ...filter, sortOrder: i };
  });
};

export default function(state = {}, action) {
  switch (action.type) {
  case UPDATE_PLUGIN_SET_FILTER_ORDER: {
    const filters = [...state.pluginFilters];
    const temp = filters[action.payload[1]];
    filters[action.payload[1]] = filters[action.payload[0]];
    filters[action.payload[0]] = temp;
    return {
      ...state,
      pluginFilters: setFilterSortOrders(filters)
    };
  }
  case UPDATE_PLUGIN_SET_FILTER: {
    const filters = [...state.pluginFilters];
    const index = findIndex(filters, f => f.id === action.payload.id);
    filters[index] = { ...filters[index], [action.payload.key]: action.payload.value };
    return {
      ...state,
      pluginFilters: filters
    };
  }
  case ADD_PLUGIN_SET_FILTER: {
    action.payload.sortOrder = state.pluginFilters.length;
    const filters = [...state.pluginFilters, action.payload];
    return {
      ...state,
      pluginFilters: filters
    };
  }
  case UPDATE_PLUGIN_SET:
    return action.payload;
  default:
    return state;
  }
}
